
import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { supabase } from "@/integrations/supabase/client";
import { useNavigate } from "react-router-dom";
import { LogOut, Settings, User } from "lucide-react";
import { useCurrentUser } from "@/hooks/useCurrentUser";

const UserAvatar = () => {
  const { currentUser, loading } = useCurrentUser();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    navigate("/");
  };

  const handleDashboard = () => {
    if (currentUser?.user_type === 'landlord') {
      navigate("/owner-dashboard");
    } else if (currentUser?.user_type === 'admin') {
      navigate("/admin");
    } else {
      navigate("/user-dashboard");
    }
  };

  if (loading) {
    return <div className="w-8 h-8 rounded-full bg-gray-300 animate-pulse" />;
  }

  if (!currentUser) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="focus:outline-none">
          <Avatar className="h-8 w-8 cursor-pointer hover:ring-2 hover:ring-blue-500 transition-all">
            <AvatarImage src={currentUser.avatar_url} alt={currentUser.full_name} />
            <AvatarFallback className="bg-blue-600 text-white text-sm">
              {currentUser.full_name ? currentUser.full_name.charAt(0).toUpperCase() : 'م'}
            </AvatarFallback>
          </Avatar>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <div className="flex items-center gap-2 p-2">
          <Avatar className="h-8 w-8">
            <AvatarImage src={currentUser.avatar_url} alt={currentUser.full_name} />
            <AvatarFallback className="bg-blue-600 text-white text-xs">
              {currentUser.full_name ? currentUser.full_name.charAt(0).toUpperCase() : 'م'}
            </AvatarFallback>
          </Avatar>
          <div className="flex flex-col space-y-1">
            <p className="text-sm font-medium leading-none">{currentUser.full_name}</p>
            <p className="text-xs leading-none text-muted-foreground">{currentUser.email}</p>
          </div>
        </div>
        <DropdownMenuSeparator />
       
        <DropdownMenuItem onClick={() => navigate('/user-dashboard')} className="cursor-pointer">
          <User className="mr-2 h-4 w-4" />
          <span>الملف الشخصي</span>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleSignOut} className="cursor-pointer text-red-600">
          <LogOut className="mr-2 h-4 w-4" />
          <span>تسجيل الخروج</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default UserAvatar;
